import { render, staticRenderFns, recyclableRender, components } from "./u-calendar.vue?vue&type=template&id=b73440ae&scoped=true&"
var renderjs
import script from "./u-calendar.vue?vue&type=script&lang=js&"
export * from "./u-calendar.vue?vue&type=script&lang=js&"
import style0 from "./u-calendar.vue?vue&type=style&index=0&id=b73440ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73440ae",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-calendar/u-calendar.vue"
export default component.exports